import { Crown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface PremiumPaywallProps {
  feature: string;
  description?: string;
}

export function PremiumPaywall({ feature, description }: PremiumPaywallProps) {
  const { t } = useTranslation();
  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center bg-surface-primary/80 backdrop-blur-sm rounded-xl overflow-hidden">
      <div className="flex flex-col items-center text-center max-w-xs px-6">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/40">
          <Crown className="h-6 w-6 text-amber-500" />
        </div>
        <h3 className="mt-4 text-sm font-semibold text-text-primary">{feature}</h3>
        <p className="mt-1 text-sm text-text-tertiary">
          {description ?? t('web:premiumPaywall.thisFeatureRequiresASharecostPremium')}
        </p>
        <div className="mt-4 rounded-lg bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 px-4 py-2.5">
          <p className="text-xs font-medium text-amber-800 dark:text-amber-300">
            {t('web:common.upgradeViaTheMobileApp')}
          </p>
        </div>
      </div>
    </div>
  );
}
